import React, { useEffect, useRef, useState } from 'react';
import SVG from 'react-inlinesvg'

import clock from '@src/images/landing/clock';
import rocket from '@src/images/landing/rocket';
import flag from '@src/images/landing/flags/finish';
import { trialRoundDates, mainRoundDates, finalRoundDates } from '@app/components/shared/StateLabel/Label';
import { getTourStatus, TourStatus } from '@app/helpers/tourStatusHelper'

const Timeline = ({ event }) => {
  const warmupRef = useRef(null)
  const finalRef = useRef(null)
  const [labelTop, setLabelTop] = useState(null)
  const [opacity, setOpacity] = useState([0.5, 0.5, 0.5])

  useEffect(() => {
    const updateStatus = () => {
      const status = getTourStatus(event)
      if (status === TourStatus.TRIAL && warmupRef.current) {
        setLabelTop(warmupRef.current.offsetTop - 30)
        setOpacity([1, 0.5, 0.5])
      } else if (status === TourStatus.MAIN) {
        setLabelTop(30)
        setOpacity([0.5, 1, 0.5])
      } else if (status === TourStatus.FINAL && finalRef.current) {
        setLabelTop(finalRef.current.offsetTop - 30)
        setOpacity([0.5, 0.5, 1])
      } else {
        setLabelTop(null)
        setOpacity([0.5, 0.5, 0.5])
      }
    }

    updateStatus()
    const intervalId = setInterval(updateStatus, 60 * 1000)

    return () => {
      clearInterval(intervalId)
    }
  }, [event])

  return (
    <div className="dinomath-timeline">
      <div className="dinomath-timeline__title" style={{ marginBottom: (getTourStatus(event) === TourStatus.TRIAL && labelTop !== null) ? 32 : 16 }}>
        Olympiad Timeline
      </div>
      <div className="dinomath-timeline__wrapper">
        {labelTop !== null && (
          <div className="dinomath-timeline__label" style={{ top: labelTop }}>
            Running now
          </div>
        )}
        <div ref={warmupRef} className="dinomath-timeline__warmup row" style={{ opacity: opacity[0] }}>
          <SVG src={clock} className="dinomath-timeline__icon" />
          <div className="dinomath-timeline__name">
            Warm-Up
          </div>
          <div className="dinomath-timeline__period">
            {trialRoundDates(event)}
          </div>
        </div>
        <div className="dinomath-timeline__main row" style={{ opacity: opacity[1] }}>
          <SVG src={rocket} className="dinomath-timeline__icon" />
          <div className="dinomath-timeline__name">
            Olympiad
          </div>
          <div className="dinomath-timeline__period">
            {mainRoundDates(event)}
          </div>
        </div>
        <div ref={finalRef} className="dinomath-timeline__final row" style={{ opacity: opacity[2] }}>
          <SVG src={flag} className="dinomath-timeline__icon" />
          <div className="dinomath-timeline__name">
            Final Round
          </div>
          <div className="dinomath-timeline__period">
            {finalRoundDates(event)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
